import React, { FunctionComponent } from 'react';
import { isGaitMlResults, UploadRequestItem } from '@companion-professional/dctypes';
import { ErrorAlert } from '@companion-professional/components';
import { GaitAnalysis } from './GaitAnalysis';

interface ItemAnalysisProps {
  requestedItem?: UploadRequestItem;
  itemMlResult?: unknown;
  goToTime: (timeInSeconds: number) => void;
}

// ItemAnalysis is a component that renders the analysis results for a requested item.  Currently, it only supports
// gait analysis results, but it is designed to be extensible for future analysis types.
export const ItemAnalysis: FunctionComponent<ItemAnalysisProps> = ({ requestedItem, itemMlResult, goToTime }) => {
  if (!itemMlResult || !requestedItem) {
    return null;
  }

  // Gait analysis results
  if (isGaitMlResults(itemMlResult)) {
    // Do not render anything for low confidence gait results or if there's an error
    if (itemMlResult.confidence === 'low' || (itemMlResult.error_type && itemMlResult.error_type !== '')) {
      return null;
    }

    return <GaitAnalysis gaitMlResult={itemMlResult} requestedItem={requestedItem} goToTime={goToTime} />;
  }

  console.error('Unknown analysis result type:', itemMlResult);
  return <ErrorAlert title="Unknown Analysis" message="Received an unknown analysis result type." />;
};
